import { HoverableButton, ReactIcons } from "@kalyzee/escaet-ui";

export const FullScreenButton: React.FC<{
  enabled: boolean;
  transparentBg?: boolean;
  setEnabled?: (value: boolean) => void;
}> = ({ enabled, transparentBg, setEnabled }) => {
  return (
    <div onClick={(e) => { e.stopPropagation(); setEnabled?.(!enabled); }}>
      {enabled ? (
        <HoverableButton.SmallScreen 
          transparentBg={transparentBg} 
          onClick={() => {}} 
          style={{ width: "2em", height: "2em" }} 
        />
      ) : (
        <HoverableButton.FullScreen 
          transparentBg={transparentBg} 
          onClick={() => {}} 
          style={{ width: "2em", height: "2em" }} 
        />
      )}
    </div>
  );
};